module.exports = __webpack_public_path__ + "static/img/top.a6a82b60.jpg";